import Button, { ButtonProps } from '@insided/control/uikit/Button'
import { Component, ComponentChild } from 'preact'
import { IconProps } from '../assets'
import DropdownList from '../dropdown/DropdownList'
import { Item } from '../dropdown/interfaces'

export interface SelectorItem extends Item {
  isPrincipal?: boolean | undefined
  disabled?: boolean | undefined
  titleWithIcon?: ComponentChild
}

interface Props {
  /**
   * @deprecated
   */
  newStyle?: boolean
  items: SelectorItem[]
  variant?: ButtonProps['variant']
  iconCloseName?: IconProps['icon']
  iconOpenName?: IconProps['icon']
  triggerButtonCustomClassName?: string
  size?: ButtonProps['size']
}

interface State {
  visible: boolean
}

export default class ButtonControlSelector extends Component<Props, State> {
  root: HTMLElement | null = null

  constructor(props: Props) {
    super(props)
    this.state = { visible: false }
    this.documentClick = this.documentClick.bind(this)
  }

  addHandler() {
    window.document.addEventListener('click', this.documentClick)
  }

  removeHandler() {
    window.document.removeEventListener('click', this.documentClick)
  }

  documentClick(e: MouseEvent) {
    const { target } = e
    function isNode(e: EventTarget | null): e is Node {
      return !!e && 'childNodes' in e
    }
    if (!this.root) return
    if (!isNode(target)) return
    if (this.root?.contains(target)) return
    this.removeHandler()
    this.setState({ visible: false })
  }

  render() {
    const {
      items,
      size,
      triggerButtonCustomClassName,
      variant = 'primary',
      iconCloseName = 'arrowDropUp',
      iconOpenName = 'arrowDropdown'
    } = this.props
    const { visible } = this.state
    const principal: SelectorItem = items.filter((item) => item.isPrincipal)[0]

    return (
      <div
        className='selector-buttons'
        ref={(el) => {
          this.root = el
        }}
      >
        <a href={principal.href}>
          <Button
            variant={variant}
            size={size}
            title={principal.titleWithIcon ?? principal.title}
            // @ts-expect-error
            onClick={principal.onClick}
            className={principal.class}
            {...(principal.disabled && { disabled: principal.disabled })}
          />
        </a>
        <Button
          variant={variant}
          size={size}
          className={triggerButtonCustomClassName}
          icon={visible ? iconCloseName : iconOpenName}
          onClick={(event) => {
            if (!visible) {
              this.addHandler()
              event.stopPropagation()
            } else {
              this.removeHandler()
            }
            this.setState({ visible: !visible })
          }}
        />
        {visible && (
          <div className='selector-wrapper'>
            <DropdownList
              align='adjust'
              items={items.filter((item) => !item.isPrincipal)}
              isOpen={visible}
              hasSearch={false}
            />
          </div>
        )}
      </div>
    )
  }
}
